import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Design } from './components';
import useRecipientQueries from './useRecipientQueries';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const RecipientQueryDesign = props => {
  const template = useRecipientQueries();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Design
          template={template}
          showNav={true}
          back="/recipient-queries/details"
        />
      </div>
    </div>
  );
};

export default RecipientQueryDesign;
